module.exports = __webpack_public_path__ + "img/gallery-17.b8c476d7.jpg";